export default __webpack_public_path__ + "static/media/login.b6b1ff85.jpg";